import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import * as billable from 'store/actions/billable.actions';
import { SearchEngineTypeValue } from 'modules/shared/models/screening.models';
var initialState = {
    credits: [],
    searchEngines: [],
    subscriptions: [],
    OCR: null,
    FC: null,
    NLP: null,
    errorMessage: null,
    loading: []
};
var searchEnginesOrder = [
    'DJ', 'DJ2', 'DJ3', 'TR', 'Internet2', 'OwnName', 'ArtemiScan'
];
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case billable.BillableActionTypes.LOAD_BILLABLE: {
            return tslib_1.__assign({}, state, { loading: action.payload.quietUpdate ? state.loading : state.loading.concat([action.type]) });
        }
        case billable.BillableActionTypes.LOAD_BILLABLE_SUCCESS: {
            var creditsArray = action.payload.credits;
            // Restricted list only artemis feature, so not included to billable API
            creditsArray.push({ display: true, serviceName: 'Own Restricted List', serviceType: 'OwnName' });
            var searchEngines = prepareSearchEngines(creditsArray);
            var FC = creditsArray.find(function (userCredit) { return userCredit.serviceType === 'FC'; }) || null;
            var OCR = creditsArray.find(function (userCredit) { return userCredit.serviceType === 'OCR'; }) || null;
            var NLP = creditsArray.find(function (userCredit) { return userCredit.serviceType === 'NLP'; }) || null;
            return tslib_1.__assign({}, state, { credits: creditsArray, subscriptions: action.payload.subscriptions, searchEngines: searchEngines, FC: FC, OCR: OCR, NLP: NLP, errorMessage: null, loading: clearLoading(state, billable.BillableActionTypes.LOAD_BILLABLE) });
        }
        case billable.BillableActionTypes.LOAD_BILLABLE_FAILURE: {
            return tslib_1.__assign({}, state, { errorMessage: action.payload.message, loading: clearLoading(state, billable.BillableActionTypes.LOAD_BILLABLE) });
        }
        // Start Check balance
        case billable.BillableActionTypes.CHECK_BALANCE: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case billable.BillableActionTypes.CHECK_BALANCE_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, billable.BillableActionTypes.CHECK_BALANCE), errorMessage: null });
        }
        case billable.BillableActionTypes.CHECK_BALANCE_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, billable.BillableActionTypes.CHECK_BALANCE), errorMessage: 'Check balance failed' });
        }
        // Start Login
        default: {
            return state;
        }
    }
}
var billableSelector = function (state) { return state.billable; };
var ɵ0 = billableSelector;
var ɵ1 = function (state) { return state.credits; }, ɵ2 = function (state) { return state.subscriptions; }, ɵ3 = function (state) { return state.searchEngines; }, ɵ4 = function (state) {
    return Object.assign([], state.searchEngines.map(function (engine) { return engine.serviceType; }));
}, ɵ5 = function (state) {
    return Object.assign([], state.searchEngines)
        .map(function (engine) { return engine.serviceType; })
        .filter(function (engineType) {
        return engineType !== SearchEngineTypeValue.INTERNET_SEARCH &&
            engineType !== SearchEngineTypeValue.OWN_NAME;
    });
}, ɵ6 = function (state) { return state.OCR; }, ɵ7 = function (state) { return state.FC; }, ɵ8 = function (state) { return state.NLP; }, ɵ9 = function (state) { return state.errorMessage; }, ɵ10 = function (state) { return state.loading; }, ɵ11 = function (state) {
    return state.searchEngines
        .filter(function (searchEngine) { return searchEngine.display && searchEngine.remaining <= 0; })
        .map(function (searchEngine) { return searchEngine.serviceName; });
};
export var Selectors = {
    getCredits: createSelector(billableSelector, ɵ1),
    getSubscriptions: createSelector(billableSelector, ɵ2),
    getSearchEngines: createSelector(billableSelector, ɵ3),
    getSearchEngineTypes: createSelector(billableSelector, ɵ4),
    getAsyncSearchEngineTypes: createSelector(billableSelector, ɵ5),
    getOCR: createSelector(billableSelector, ɵ6),
    getFC: createSelector(billableSelector, ɵ7),
    getNLP: createSelector(billableSelector, ɵ8),
    getError: createSelector(billableSelector, ɵ9),
    getLoading: createSelector(billableSelector, ɵ10),
    getSubscribedButNoCreditEngines: createSelector(billableSelector, ɵ11)
};
function prepareSearchEngines(credits) {
    var searchEngines = [];
    searchEnginesOrder.forEach(function (searchEngineKey) {
        var searchEngine = credits.find(function (userCredit) {
            return userCredit.serviceType !== 'FC'
                && userCredit.serviceType !== 'OCR'
                && userCredit.serviceType !== 'NLP'
                && userCredit.serviceType === searchEngineKey;
        });
        if (searchEngine) {
            searchEngines.push(searchEngine);
        }
    });
    return searchEngines;
}
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
